import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { blogKeys } from "./keys";

export const useCreateBlogArticle = () => {
	const mutation = useMutation({ mutationFn: Api.Blog.postApiBlog, mutationKey: blogKeys.create });
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
